import AxiosPermisos  from '@/services/axiosPermisos'

import { routes } from './path'

async function getRisksService () {
    return await AxiosPermisos.get(
        routes.risks
        , true
        , 'v2'
    )
}

export {
    getRisksService
}